// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 803 ? "maplibre" : chunkId) + "." + {"119":"49e33c1d","803":"b6dcc03c"}[chunkId] + ".chunk.js";
};